// Content container for pages which use structure of banner, tabs and content with or without sidebar
import React from "react";

const ContentContainer = ({ mode, children, extraClasses }) => {

  const modeClasses = {
    default: "flex-col items-start justify-start",
    gamestats: "flex-col lg:flex-row",
  };

  const modeClass = modeClasses[mode] || modeClasses.default;

  return (
    <div
      className={`contentContainer px-2 xxs:px-4 lg:px-8 flex w-full ${modeClass} ${extraClasses}`}
    >
      {children}
    </div>
  );
};

export default ContentContainer;
